export default "__VITE_ASSET__DzphQhZm__"